var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.501 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.bdfas843uir{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H23.5V23.5H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bdfas843uir",
    d: "M10.834,17.75h1.958a.979.979,0,1,0,0-1.958H10.834a.979.979,0,1,0,0,1.958ZM3,6.979a.982.982,0,0,0,.979.979H19.646a.979.979,0,1,0,0-1.958H3.979A.982.982,0,0,0,3,6.979Zm3.917,5.875h9.792a.979.979,0,1,0,0-1.958H6.917a.979.979,0,1,0,0,1.958Z",
    transform: "translate(-0.062 -0.125)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.03f23e11.svg";
export { ForwardRef as ReactComponent };